import { render, staticRenderFns } from "./BoQuiz.vue?vue&type=template&id=3576923a&"
import script from "./BoQuiz.vue?vue&type=script&lang=js&"
export * from "./BoQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports